import PropTypes from 'prop-types';
import React from 'react';
// import { propTypes as rowPropTypes } from './row';
import PremiumCard from '../card/premium_card';
import getUniqueKeyForCard from '../../utils/getUniqueKeyForCard';

export default function ThreePremiumCardsRow(props, context) {
  const { cards, dataAttributes, type, moduleType } = props;
  const { isPreviewPage } = context;
  const threePremiumCards = cards.slice(0, 3).map(card => {
    const key = getUniqueKeyForCard(card, isPreviewPage);
    return (
      <PremiumCard {...card} rowType={type} moduleType={moduleType} key={key} />
    );
  });
  return (
    <div className="row three-premium" {...dataAttributes}>
      {threePremiumCards}
    </div>
  );
}

// ThreePremiumCardsRow.propTypes = Object.assign({}, rowPropTypes, {
//   dataAttributes: PropTypes.object.isRequired
// });

ThreePremiumCardsRow.contextTypes = {
  isPreviewPage: PropTypes.bool.isRequired
};
